import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pt_card",
  "use": "icon-pt_card-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-pt_card\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M4,4h7.11v7.11H4Zm0,8.89h7.11V20H4ZM12.89,4H20v7.11H12.89Zm0,8.89H20V20H12.89Zm1.78-7.11V9.33h3.55V5.78Zm0,8.89v3.55h3.55V14.67ZM5.78,5.78V9.33H9.33V5.78Zm0,8.89v3.55H9.33V14.67Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol